// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FacultyPeers_faculty-peers__3y-Q1 .FacultyPeers_header__yc770 {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 25px;
  align-items: flex-start;
}
.FacultyPeers_faculty-peers__3y-Q1 .FacultyPeers_header__yc770 .FacultyPeers_filter__-W7dO {
  display: flex;
  align-items: center;
  gap: 30px;
}
.FacultyPeers_faculty-peers__3y-Q1 .FacultyPeers_header__yc770 .FacultyPeers_mode-select__1StUh {
  display: flex;
  align-items: center;
  gap: 8px;
}
.FacultyPeers_faculty-peers__3y-Q1 .FacultyPeers_header__yc770 .FacultyPeers_mode-select__1StUh p {
  color: var(--dark-grey);
}
.FacultyPeers_faculty-peers__3y-Q1 .FacultyPeers_peer__-5dY- {
  display: flex;
  align-items: flex-start;
  margin-bottom: 25px;
}
.FacultyPeers_faculty-peers__3y-Q1 .FacultyPeers_peer__-5dY- .FacultyPeers_avatar__v6H76 {
  width: 60px;
  height: 60px;
  position: relative;
  margin-right: 20px;
}
.FacultyPeers_faculty-peers__3y-Q1 .FacultyPeers_peer__-5dY- .FacultyPeers_avatar__v6H76 .FacultyPeers_photo__PICue {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
}
.FacultyPeers_faculty-peers__3y-Q1 .FacultyPeers_peer__-5dY- .FacultyPeers_info__SgXNT p {
  margin-bottom: 3px !important;
}
.FacultyPeers_faculty-peers__3y-Q1 .FacultyPeers_peer__-5dY- .FacultyPeers_info__SgXNT .FacultyPeers_name__Yjd-X {
  font-weight: bold;
  cursor: pointer;
}
.FacultyPeers_faculty-peers__3y-Q1 .FacultyPeers_peer__-5dY- .FacultyPeers_info__SgXNT .FacultyPeers_name__Yjd-X:hover {
  text-decoration: underline;
  color: var(--blue);
}
.FacultyPeers_faculty-peers__3y-Q1 .FacultyPeers_peer__-5dY- .FacultyPeers_info__SgXNT .FacultyPeers_inst-name__hh91w:hover {
  text-decoration: underline;
  color: var(--blue);
}
.FacultyPeers_faculty-peers__3y-Q1 .FacultyPeers_peer__-5dY- .FacultyPeers_info__SgXNT p {
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/FacultyDetail/Components/FacultyPeers/FacultyPeers.module.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AAAJ;AACI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACN;AAEI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAAN;AACM;EACE,uBAAA;AACR;AAGE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AADJ;AAGI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AADN;AAGM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AADR;AAMM;EACE,6BAAA;AAJR;AAOM;EACE,iBAAA;EACA,eAAA;AALR;AAOQ;EACE,0BAAA;EACA,kBAAA;AALV;AAUQ;EACE,0BAAA;EACA,kBAAA;AARV;AAYM;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAVR","sourcesContent":[".faculty-peers {\n  .header {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-bottom: 25px;\n    align-items: flex-start;\n    .filter {\n      display: flex;\n      align-items: center;\n      gap: 30px;\n    }\n\n    .mode-select {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      p {\n        color: var(--dark-grey);\n      }\n    }\n  }\n  .peer {\n    display: flex;\n    align-items: flex-start;\n    margin-bottom: 25px;\n\n    .avatar {\n      width: 60px;\n      height: 60px;\n      position: relative;\n      margin-right: 20px;\n\n      .photo {\n        width: 60px;\n        height: 60px;\n        border-radius: 50%;\n        object-fit: cover;\n      }\n    }\n\n    .info {\n      p {\n        margin-bottom: 3px !important;\n      }\n\n      .name {\n        font-weight: bold;\n        cursor: pointer;\n\n        &:hover {\n          text-decoration: underline;\n          color: var(--blue);\n        }\n      }\n\n      .inst-name {\n        &:hover {\n          text-decoration: underline;\n          color: var(--blue);\n        }\n      }\n\n      p {\n        display: -webkit-box;\n        -webkit-line-clamp: 6;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"faculty-peers": `FacultyPeers_faculty-peers__3y-Q1`,
	"header": `FacultyPeers_header__yc770`,
	"filter": `FacultyPeers_filter__-W7dO`,
	"mode-select": `FacultyPeers_mode-select__1StUh`,
	"peer": `FacultyPeers_peer__-5dY-`,
	"avatar": `FacultyPeers_avatar__v6H76`,
	"photo": `FacultyPeers_photo__PICue`,
	"info": `FacultyPeers_info__SgXNT`,
	"name": `FacultyPeers_name__Yjd-X`,
	"inst-name": `FacultyPeers_inst-name__hh91w`
};
export default ___CSS_LOADER_EXPORT___;
